<template>
  <div class="row">
      <form-input class="col-5" :model="initContactModel" attribute="domain" :errors="formErrors"
        placeholder="Domain"></form-input>
      <form-input class="col-5" :model="initContactModel" attribute="phone" :errors="formErrors"
        placeholder="Số điện thoại"></form-input>
      <div class="col-2">
        <button class="btn btn-primary mr-1 mb-1" @click="initContact"
          :disabled="!initContactModel.domain || !initContactModel.phone">Run</button>
      </div>
    </div>
</template>
<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";

export default {
  name: "tool-contact",
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/tool',
      autoLoad: true,
      initContactModel: {
        domain: null,
        phone: null
      },
      formErrors: []
    }
  },
  methods: {
    onCopy() {
      this.$swal({
        text: this.$t('tokenCopied'),
        icon: 'success',
        toast: true,
        position: 'top-end',
        timer: 5000,
      });
    },
    onError() {
      this.$swal({
        title: this.$t('error'),
        text: this.$t('copyFailed'),
        icon: 'error'
      });
    },
    initContact() {
      let loader = this.$loading.show();
      this.$service({ url: 'tool/init-contact', method: 'post', data: this.initContactModel }).then(response => {
        if (response.data) {
          this.$swal({
            title: 'Đẹp trai rồi nhớ',
            text: 'Chắc thế...',
            icon: 'success'
          });
          this.initContactModel.domain = null;
          this.initContactModel.phone = null;
        } else {
          this.$swal({
            title: 'Ôi bome',
            text: 'Bị sao í',
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    }
  },
  i18n: {
    messages: {
      en: {
        copy: "Copy",
        tokenCopied: "Token copied!",
        copyFailed: "Fail to copy token"
      },
      vi: {
        copy: "Sao chép",
        tokenCopied: "Token đã được sao chép!",
        copyFailed: "Thất bại trong việc sao chép token"
      }
    }
  }
}
</script>
